var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrosoftExcelLogo = function SvgIconMicrosoftExcelLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.713 8.95a1 1 0 0 1 1.4.2L9 10.333l.887-1.183a1 1 0 0 1 1.6 1.2L10.25 12l1.238 1.65a1 1 0 0 1-1.6 1.2L9 13.667l-.887 1.183a1 1 0 1 1-1.6-1.2L7.75 12l-1.237-1.65a1 1 0 0 1 .2-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 5.375H3.75A1.75 1.75 0 0 0 2 7.125v9.75c0 .966.784 1.75 1.75 1.75H5v1.625A1.75 1.75 0 0 0 6.75 22h12a1.75 1.75 0 0 0 1.75-1.75V3.75A1.75 1.75 0 0 0 18.75 2h-12A1.75 1.75 0 0 0 5 3.75zm2 0h4.75V4H7zm-3 2v9.25h10v-9.25zM16 8v-.875a1.75 1.75 0 0 0-1.75-1.75h-.5V4h4.75v4zm2.5 2H16v4h2.5zM16 16v.875a1.75 1.75 0 0 1-1.75 1.75h-.5V20h4.75v-4zm-4.25 2.625H7V20h4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMicrosoftExcelLogo;